import styled from 'styled-components';

export const PipePuzzleTable = styled.table`
`;

export const PPR = styled.tr`
margin: 0;
padding: 0;
`;

export const PPD = styled.td`
margin: 0;
padding: 0;
`;

export const Outflow = styled(PPD)`
display: flex;
justify-content: flex-end;

span {
  alignContent: center;
}
`;

export const LocalStorage = styled(Outflow)`
justify-content: flex-start;
`;

export const TransferStation = styled(LocalStorage)`
`;

export const PipeImg = styled.img<{ src: string, alt: string, flowing?: boolean }>`
height: 2em;
width: 2em;
filter: ${(props) => props.flowing ? 'invert(84%) sepia(15%) saturate(467%) hue-rotate(148deg) brightness(98%) contrast(91%);' : ''}
`;
